import styled from "styled-components";
import { Atom } from 'AppReact';

export const template = styled.div`
  width: 100%;
  object-fit: cover;
  height: 100%;
  background: #E3E3E3;
`;

export default Atom({ type: 'image', dataType: 'string', template })
